import ContractCard from "./ContractCard";

export default ContractCard;
